<template>
    <div id="root-mock-picker">

        <!--<select name="rootmockpick" id=""  v-model="selectedCompany">-->
        <!--<option v-for="company in companyList"  :value="company.id">-->
        <!--{{company.name}}-->
        <!--</option>-->
        <!--</select>-->

        <a class="btn btn-default  " data-toggle="dropdown"><i class="fas fa-fingerprint"></i></a>

        <ul class="dropdown-menu scrollable-menu" role="menu">
            <li><input type="text" v-model="search"></li>
            <li v-for="(company,idx) in filteredCompanyList" :key="company.id">
                <a class="company-link" href="javascript:;" @click="mockCompanyClicked(company)">{{company.name}}</a>
            </li>
        </ul>

    </div>
</template>

<script>

    export default {
        props: ['companyList'],
        data() {
            return {
                selectedCompany: null,
                search: ''
            }
        },
        methods: {
            mockCompanyClicked(company) {
                this.selectedCompany = company
                this.search = ''
            }
        },
        computed: {
            filteredCompanyList() {
                var self = this
                return this.companyList.filter(function (company) {
                    return company.name.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
                });
            }
        },
        watch: {
            selectedCompany(newVal,oldVal) {

                this.$store.dispatch('root/MockCompany',newVal.id)
            }
        },
        created() {

        }
    }
</script>
<style scoped lang="scss">
    #root-mock-picker {
        position: fixed;
        bottom: 10px;
        right: 10px;
        z-index: 1040;

    }

    .fa-fingerprint {
        background:   linear-gradient(90deg, rgba(153, 204, 153, 0.95) 0, rgba(0, 201, 255, 0.95) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 30px;
        background-size: 100% 100%;
        transition:all 1s ease;
        &:hover{
            background-size: 200% 200%;
            transform:rotate(-10deg);
        }
    }

    .company-link{
        display:block;
        padding:2px 2px;
        text-transform: capitalize;
        width:100%;
        border-bottom:1px solid rgba(14, 0, 128, 0.18);

    }
    .scrollable-menu {
        height: auto;
        min-height:300px;
        max-height: 300px;
        overflow-x: hidden;
        &::-webkit-scrollbar {
            width: 6px;
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #484848;
        }
    }



</style>
